import { useState, useContext } from "react";
import { useQuery } from '@tanstack/react-query';
import { useMediaQuery } from 'react-responsive';

import MobileHome from "../layouts/MobileLayout/MobileHome";

import useAxios from "./useAxios";
import authAxios from "./authAxios";
import {UserContext} from "../App"
import DashboardHeader from "./DashboardHeader";
import 'chart.js/auto'
import { Bar, Doughnut } from "react-chartjs-2";
import moment from 'moment';
import Loading from "./Loading";

function Dashboard() {
    const isMobile = useMediaQuery({ query: '(max-width: 750px)' })
    const {page_size} = useContext(UserContext);
    const { loading } = useAxios()
    const {clientProfile} = useContext(UserContext);

    const [customerCount, setCustomerCount] = useState(0);
    const [occupancy, setOccupancy] = useState(0.00);

    const { data: dashboard } = useQuery({
        queryKey: ['dashboard'],
        queryFn: async () => {
            const response = await authAxios.get(`/bi/dashboard/${localStorage.getItem('clientProfile')}`);
            return response.data;
        },
        enabled: !isMobile,
    });


    const { data: kpis } = useQuery({
        queryKey: ['kpis'],
        queryFn: async () => {
          const response = await authAxios.get(`/bi/kpis/?page_size=${page_size}`);
          const customerCountKpi = response.data.find(kpi => kpi.type_code === "00100")
          setCustomerCount(customerCountKpi.value)
          const occupancyKpi = response.data.find(kpi => kpi.type_code === "00200")
          setOccupancy(occupancyKpi.value)
          return response.data;
        },
        enabled: !isMobile,
    });

    const [expenseData, setExpenseData] = useState({})
    const [viewChart, setViewChart] = useState(false)


    const { data: accounts } = useQuery({
        queryKey: ['accounts'],
        queryFn: async () => {
            const response = await authAxios.get(`/accounting/accounts?page_size=${page_size}`);
            setViewChart(true)
            // createChart()
            const expaccts = Array.from(response.data.results).filter(account => account.type_code === "20100")
            setExpenseData({
                labels: expaccts.map((expacct) => expacct.name),
                datasets: [
                {
                    label: "Expenses",
                    data: expaccts.map((expacct) => expacct.balance),
                    backgroundColor: [
                        "#ecf0f1",
                        "#50AF95",
                        // "#d81159", //Added
                        "#ffafcc", //Added
                        "#3a86ff", //Added
                        "#8338ec", //Added
                        "#38b000", //Added
    
    
                        "#f3ba2f",
                        "#2a71d0",
                    ],
                },
                ],
            });
            return response.data.results;
        },
        enabled: !isMobile,
    });

    const [revenueData, setRevenueData] = useState({})
    const [viewBarChart, setViewBarChart] = useState(false)


    const { data: monthlyRevenue } = useQuery({
        queryKey: ['monthlyRevenue'],
        queryFn: async () => {
            const response = await authAxios.get("/accounting/monthly-revenue");

            setViewBarChart(true)        
                setRevenueData({
                    labels: response.data.map((period) => moment().month(period.month-1).format("MMM")),

                    datasets: [
                    {
                        label: "Revenue",
                        data: response.data.map((period) => period.amount),
                        backgroundColor: [
                            "#ecf0f1",
                            "#50AF95",
                            "#d81159", //Added
                            "#f3ba2f",
                            "#2a71d0",
                        ],
                    },
                    ],
                });
            // }
            return response.data;
        },
        enabled: !isMobile,
    });

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: 20,
        },
        plugins: {
            legend: {
                // display: false,
                position: 'right',
                labels: {
                    font: {
                        size: 11,
                    }
                }
            }
        }
    }

    const barChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: 20,
        },
        plugins: {
            legend: {
                display: false,
                labels: {
                    font: {
                        size: 8,
                    }
                }
            }
        },
        scales: {
            x: {
              grid: {
                display: false,
              },
            },
      
            y: {
              grid: {
                color: 'rgba(217,143,7,0.1)',
              },
              display: false,
            },
        }
    }




    // Must stay below the hooks above: isMobile flips on resize/rotate,
    // and returning earlier would change this component's hook count.
    if (isMobile) return <MobileHome />;

    return (
            <div className="dashboard-main">
                
                
                <section className="dashboard-content">

                    <DashboardHeader dashboardTitle="Insights" dashboardPreTitle="Dashboard" />

                    {loading? <Loading loading={loading}/>
                    :
                    <>

                    <div className="dashboard-content-subheader" id="dashboard-charts">


                        <div className='dashboard-card'>
                            <div className="dashboard-card-pretitle">
                                Revenue
                            </div>
                            {viewBarChart && 

                            <div className="dashboard-card-chart">
                                <Bar data={revenueData} options={barChartOptions}/>
                            </div>
                            }

                        </div>
                        <div className='dashboard-card'>
                            <div className="dashboard-card-pretitle">
                                Expenses
                            </div>

                            { viewChart && 
                                <div className="dashboard-card-chart" >
                                    <Doughnut 
                                        data={expenseData} 
                                        options={chartOptions}/>
                                </div>

                            }
                        </div>
                    </div>

                    <div className="dashboard-content-subheader" id="dashboard-landing">
                        <div className='dashboard-card'>
                            <div className="dashboard-card-pretitle">
                                Applications
                            </div>
                            <div className="dashboard-card-text">
                                {/* {dashboard && Math.round(dashboard.property_count).toLocaleString()} */}
                                0
                            </div>
                        </div>
                        <div className='dashboard-card'>
                            <div className="dashboard-card-pretitle">
                                Loans
                            </div>
                            <div className="dashboard-card-text">
                                {/* {Math.round(customerCount).toLocaleString()} */}
                                0
                            </div>
                        </div>
                        <div className='dashboard-card'>
                            <div className="dashboard-card-pretitle">
                                Portfolio as Risk
                            </div>
                            <div className="dashboard-card-text">
                                {/* <td>{Number(occupancy).toLocaleString('en-UK', { style: 'percent', minimumFractionDigits: 2 })}</td> */}
                                0%
                            </div>
                        </div>
                      
                        <div className='dashboard-card'>
                            <div className="dashboard-card-pretitle">
                                Outstanding Loans
                            </div>
                            <div className="dashboard-card-text">
                                {clientProfile && clientProfile.currency_code} {dashboard && dashboard.creditors.toLocaleString()}

                            </div>
                        </div>
                        <div className='dashboard-card'>
                            <div className="dashboard-card-pretitle">
                                Deposits
                            </div>
                            <div className="dashboard-card-text">
                            </div>
                            
                        </div>
                        <div className='dashboard-card'>
                            <div className="dashboard-card-pretitle">
                                Bank/Cash
                            </div>
                            <div className="dashboard-card-text">
                                {clientProfile && clientProfile.currency_code} {dashboard && dashboard.bank_cash_balance.toLocaleString()}
                            </div>
                            
                        </div>
                        

                    </div>
                    </>
                    }
                </section>
            </div>

    ) 

}

export default Dashboard